import { render, staticRenderFns } from "./TimetableMetaEdit.vue?vue&type=template&id=6688e680"
import script from "../../controllers/timetable_meta/timetable-meta-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/timetable_meta/timetable-meta-edit.js?vue&type=script&lang=js&external"
import style0 from "./TimetableMetaEdit.vue?vue&type=style&index=0&id=6688e680&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports